<div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
  <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-3" [formGroup]="schedule">
    <input
      type="number"
      formControlName="value"
      min="1"
      class="tw-w-20 tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm tw-text-gray-900 dark:tw-border-gray-600 dark:tw-bg-gray-800 dark:tw-text-white"
      [ngClass]="{ 'tw-border-red-500': schedule.errors && schedule.dirty }"
      [attr.disabled]="schedule.value?.done ? '' : null"
      (input)="preventDecimalNumbersCheck()"
    />
    <select
      formControlName="type"
      class="tw-min-w-[220px] tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white tw-px-3 tw-py-1.5 tw-text-sm tw-text-gray-900 dark:tw-border-gray-600 dark:tw-bg-gray-800 dark:tw-text-white"
      [attr.disabled]="schedule.value?.done ? '' : null"
    >
      <option value="" disabled>Duration before event ...</option>
      <option value="minute">{{ types.minute.text }}</option>
      <option value="hour">{{ types.hour.text }}</option>
      <option value="day">{{ types.day.text }}</option>
    </select>
    @if (!isFirstSchedule) {
    <strong class="tw-text-sm tw-text-gray-700 dark:tw-text-gray-200">
      ({{ (reminderPrice?.amount / 100)?.toFixed(2) | currency: reminderPrice?.currency?.toUpperCase() : 'symbol-narrow' : '1.2-2' }}/Reminder)
    </strong>
    }
  </div>
  @if (!isFirstSchedule && !isOnlySchedule && !schedule.value?.done) {
  <button type="button" class="tw-border-0 tw-bg-transparent tw-p-1 tw-text-gray-500" aria-label="Remove reminder" (click)="removeReminder()">
    <svg class="tw-h-4 tw-w-4" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path d="M2 2l8 8M10 2 2 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
    </svg>
  </button>
  }
</div>
<div class="tw-h-6 tw-text-xs tw-mt-1 tw-text-red-600">
  @switch (firstErrorKey()) {
  @case ('notificationPassed') {
  <span>This time has already passed</span>
  } @case ('notUnique') {
  <span>Duplicate reminders found</span>
  } @case ('max') {
  <span>Exceeded maximum value</span>
  } @case ('min') {
  <span>At least 1 {{ schedule.value.type }}</span>
  } }
</div>
